import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CtNavKeys } from '@cloud-twin-v2/navigation/ct-nav-keys';
import { AuthGuard } from '@common-modules/shared/auth/services/auth.guard';
import { ModelVersionPageComponent } from './model-version-page/model-version-page.component';

const routes: Routes = [
  {
    path: '',
    component: ModelVersionPageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.ModelVersions,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModelVersionRoutingModule {}
